import { useEditor } from '@splashthat/splash-cms-engine';

export function BaseRenderer({ portal, children }) {
    const editor = useEditor((state) => ({
        nodes: state.nodes,
    }));

    return children({ nodes: editor.nodes, portal });
}
